import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";

function BalanceGeneral() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;

  const [comments, setComments] = useState([]);

  const money = (n) =>
  Number(n ?? 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  });

useEffect(() => {
  axios
    .get(`${URL_DASHBOARDS}BalanceGeneral`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {

      const {
        positivos = {},
        negativos = {},
        totalAFavor = 0,
        totalEnContra = 0,
        balance = 0,
      } = response.data || {};

      const rows = [
        { tipo: "blank" },

        { label: "Inventario Telas", value: positivos.inventarioTelas ?? 0, tipo: "row" },
        { label: "Inventario Articulos", value: positivos.inventarioArticulos ?? 0, tipo: "row" },
        { label: "Cuentas Por Cobrar", value: positivos.cuentasPorCobrar ?? 0, tipo: "row" },
        { label: "Pendientes Recibir Maquila", value: positivos.pendientesRecibirMaquila ?? 0, tipo: "row" },

        { label: "Total a Favor", value: totalAFavor, tipo: "total" },

        { tipo: "blank" },

        { label: "CxP Proveedores", value: negativos.cxpProveedores ?? 0, tipo: "row" },
        { label: "CxP Maquileros", value: negativos.cxpMaquileros ?? 0, tipo: "row" },
        { label: "Gastos sin pagar", value: negativos.gastosSinPagar ?? 0, tipo: "row" },

        { label: "Total en Contra", value: totalEnContra, tipo: "total" },

        { tipo: "blank" },

        { label: "Balance", value: balance, tipo: "balance" },
      ];

      setComments(rows);
    })
    .catch((err) => {
      console.error("❌ BalanceGeneral error:", err);
    });
}, []);



  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_balance ? (
        <div className="card container col-7">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuReportes"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            
          </Row>
          <h3 align="center"> Balance General</h3>
<Table size="sm" striped borderless className="table-responsive-xl">
  <tbody>
    {comments.map((r, idx) => {
      if (r.tipo === "blank") {
        return (
          <tr key={`blank-${idx}`}>
            <td colSpan={2} style={{ height: 14 }} />
          </tr>
        );
      }

      const isTotal = r.tipo === "total";
      const isBalance = r.tipo === "balance";

      return (
        <tr key={`row-${idx}`}>
          <td
            style={{
              fontWeight: isTotal || isBalance ? "bold" : "normal",
            }}
          >
            {r.label}
          </td>

          <td
            style={{
              textAlign: "right",
              fontWeight: isTotal || isBalance ? "bold" : "normal",
              borderTop: isTotal ? "1px solid #ddd" : undefined,
              borderBottom: isBalance ? "2px solid #000" : undefined,
            }}
          >
            {money(r.value)}
          </td>
        </tr>
      );
    })}
  </tbody>
</Table>


        </div>
      ) : undefined}
      <br />
    </>
  );
}

export default BalanceGeneral;
